<template>
  <div class="pdf-generator">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>PDF生成器</span>
        </div>
      </template>

      <el-form
        ref="generateForm"
        :model="formData"
        :rules="rules"
        label-width="120px"
        class="generate-form"
      >
        <el-form-item label="选择算法" prop="algorithmId">
          <el-select
            v-model="formData.algorithmId"
            placeholder="请选择算法模型"
            style="width: 100%"
            @change="handleAlgorithmChange"
          >
            <el-option
              v-for="algorithm in algorithms"
              :key="algorithm.id"
              :label="algorithm.name"
              :value="algorithm.id"
            >
              <div>
                <div>{{ algorithm.name }}</div>
                <div style="font-size: 12px; color: #999">
                  {{ algorithm.description }}
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="算法描述" v-if="selectedAlgorithm">
          <el-alert
            :title="selectedAlgorithm.description"
            type="info"
            :closable="false"
            show-icon
          />
        </el-form-item>

        <!-- 动态表单字段 -->
        <div v-if="selectedAlgorithm">
          <!-- 01 请输入公司和岗位，用空格隔开(多个岗位用空格隔开)： -->
          <el-form-item label="01 请输入公司和岗位，用空格隔开：" prop="title" label-style="display: block; margin-bottom: 8px;" >

            <el-input v-model="formData.title" placeholder="请输入..." />
          </el-form-item>

          <!-- 02 是否要生成该公司的组织架构、企业文化、薪资待遇考情分析等内容（耗时较长），输入是或者 -->
          <el-form-item label="02 是否要生成企业文化等" prop="question1" label-style="display: block; margin-bottom: 8px;" >
            <div></div>
            <el-radio-group v-model="formData.question1">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <!--03 是否要生成该公司的经典面试真题56道，输入是或者否： -->
          <el-form-item label="03 生成经典56道" prop="question2" label-style="display: block; margin-bottom: 8px;" >
            <div></div>
            <el-radio-group v-model="formData.question2">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 04 是否要生成该公司的结构化经典面试真题39道，输入是或者否： -->
          <el-form-item label="04 生成结构化面试39道" prop="question3" label-style="display: block; margin-bottom: 8px;" >
              <div></div>
            <el-radio-group v-model="formData.question3">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 05 可以添加任何备注（第一个备注） -->
          <el-form-item label="05 给56题添加要求(如生成的内容为英文)" prop="note1" label-style="display: block; margin-bottom: 8px;" >
              <div></div>
            <el-input v-model="formData.note1" placeholder="请输入..." />
          </el-form-item>

          <!-- 06 可以添加任何备注（第二个备注） -->
          <el-form-item label="06 给40题添加要求(如必须要社招的面试回答)" prop="note2" label-style="display: block; margin-bottom: 8px;" >
              <div></div>
            <el-input v-model="formData.note2" placeholder="请输入..." />
          </el-form-item>
        </div>

        <el-form-item>
          <el-button
            type="primary"
            size="large"
            :loading="generating"
            @click="generatePdf"
            :disabled="
              !formData.algorithmId ||
              !formData.title.trim() ||
              !formData.question1 ||
              !formData.question2 ||
              !formData.question3
            "
          >
            <el-icon v-if="!generating"><DocumentAdd /></el-icon>
            {{ generating ? "生成中..." : "生成PDF" }}
          </el-button>
          <el-button size="large" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 生成历史 -->
    <el-card style="margin-top: 20px" v-if="recentGenerations.length > 0">
      <template #header>
        <div class="card-header">
          <span>最近生成</span>
          <el-button type="text" @click="$router.push('/pdfs')"
            >查看全部</el-button
          >
        </div>
      </template>

      <el-table :data="recentGenerations" style="width: 100%">
        <el-table-column prop="filename" label="文件名" />
        <el-table-column prop="algorithm_type" label="算法类型" width="150" />
        <el-table-column prop="created_at" label="生成时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button type="text" @click="downloadPdf(scope.row.filename)">
              <el-icon><Download /></el-icon>
              下载
            </el-button>
            <el-button
              type="text"
              @click="deletePdf(scope.row.id)"
              style="color: #f56c6c"
            >
              <el-icon><Delete /></el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRoute } from "vue-router";
import axios from "axios";

export default {
  name: "PdfGenerator",
  setup() {
    const route = useRoute();
    const generateForm = ref(null);
    const generating = ref(false);
    const algorithms = ref([]);
    const recentGenerations = ref([]);

    const formData = reactive({
      algorithmId: null,
      title: "",
      question1: "",
      question2: "",
      question3: "",
      note1: "",
      note2: "",
    });

    const rules = {
      algorithmId: [
        { required: true, message: "请选择算法模型", trigger: "change" },
      ],
      title: [{ required: true, message: "请输入主题", trigger: "blur" }],
    };

    const selectedAlgorithm = computed(() => {
      return algorithms.value.find((alg) => alg.id === formData.algorithmId);
    });

    const loadAlgorithms = async () => {
      try {
        const response = await axios.get("/api/algorithms");
        algorithms.value = response.data.algorithms;
      } catch (error) {
        ElMessage.error("加载算法列表失败");
      }
    };

    const loadRecentGenerations = async () => {
      try {
        const response = await axios.get("/api/pdfs");
        recentGenerations.value = response.data.pdfs.slice(0, 5);
      } catch (error) {
        console.error("加载最近生成记录失败:", error);
      }
    };

    const handleAlgorithmChange = () => {
      // 清空表单数据
      formData.title = "";
      formData.question1 = "";
      formData.question2 = "";
      formData.question3 = "";
      formData.note1 = "";
      formData.note2 = "";
    };

    const generatePdf = async () => {
      if (!generateForm.value) return;

      try {
        await generateForm.value.validate();
        generating.value = true;

        const response = await axios.post("/api/generate-pdf", {
          algorithm_id: formData.algorithmId,
          parameters: {
            title: formData.title,
            question1: formData.question1,
            question2: formData.question2,
            question3: formData.question3,
            note1: formData.note1,
            note2: formData.note2,
          },
        });

        ElMessage.success(response.data.message);

        // 重新加载最近生成记录
        await loadRecentGenerations();

        // 可选：清空表单或跳转到PDF列表
        // resetForm()
      } catch (error) {
        if (error.response) {
          ElMessage.error(error.response.data.message || "PDF生成失败");
        } else {
          ElMessage.error("网络错误，请稍后重试");
        }
      } finally {
        generating.value = false;
      }
    };

    const resetForm = () => {
      if (generateForm.value) {
        generateForm.value.resetFields();
      }
      formData.algorithmId = null;
      formData.title = "";
      formData.question1 = "";
      formData.question2 = "";
      formData.question3 = "";
      formData.note1 = "";
      formData.note2 = "";
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    };

    const downloadPdf = async (filename) => {
      try {
        const response = await axios.get(`/api/pdfs/${filename}/download`, {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        ElMessage.success("下载成功");
      } catch (error) {
        ElMessage.error("下载失败");
      }
    };

    const deletePdf = async (pdfId) => {
      try {
        await ElMessageBox.confirm("确定要删除这个PDF文件吗？", "确认删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        await axios.delete(`/api/pdfs/${pdfId}`);
        ElMessage.success("删除成功");

        // 重新加载列表
        await loadRecentGenerations();
      } catch (error) {
        if (error !== "cancel") {
          ElMessage.error("删除失败");
        }
      }
    };

    // 监听路由变化，重置表单
    watch(
      () => route.path,
      () => {
        resetForm();
        loadRecentGenerations();
      }
    );

    onMounted(() => {
      loadAlgorithms();
      loadRecentGenerations();
    });

    return {
      generateForm,
      formData,
      rules,
      generating,
      algorithms,
      selectedAlgorithm,
      recentGenerations,
      handleAlgorithmChange,
      generatePdf,
      resetForm,
      formatDate,
      downloadPdf,
      deletePdf,
    };
  },
};
</script>

<style scoped>
.pdf-generator {
  max-width: 800px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.generate-form {
  padding: 20px 0;
}

.parameter-help {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.help-text {
  color: #666;
  font-size: 14px;
}

.el-select .el-select-dropdown__item {
  height: auto;
  padding: 10px 20px;
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  .pdf-generator {
    max-width: 100%;
    margin: 0;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .generate-form {
    padding: 15px 0;
  }
  
  .parameter-help {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .help-text {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .generate-form {
    padding: 10px 0;
  }
  
  .parameter-help {
    padding: 8px;
  }
}
</style>
